// The shared hero banner, now used only by AboutPage — every other hand-built
// page lives in src/content/pages as block data. Once ContentPage's hero moves
// into its own module, AboutPage can render that and this file goes away.
import { HEADING, TYPE } from 'styles/theme';
import { MEDIA } from 'styles/blocks';

/** Page shell: shared hero banner, then whatever section content the page needs. */
export function StaticMarketingPage({ banner, children }) {
  return (
    <div>
      <PageBanner {...banner} />
      {children}
    </div>
  );
}

export function PageBanner({
  image,
  title,
  minHeight = MEDIA.hero.minHeight,
  align = 'center',
  titleSize = TYPE.heroTitle,
  overlay = MEDIA.hero.overlay,
}) {
  const isLeft = align === 'left';
  return (
    <section style={{
      minHeight, display: 'flex', alignItems: 'center',
      justifyContent: isLeft ? 'flex-start' : 'center',
      backgroundImage: `linear-gradient(${overlay}, ${overlay}), url(${image})`,
      backgroundSize: 'cover', backgroundPosition: 'center',
    }}>
      <h1 style={{
        ...HEADING, color: '#fff', fontSize: titleSize, margin: 0,
        lineHeight: 1.15, padding: isLeft ? '0 8vw' : 0,
      }}>
        {title}
      </h1>
    </section>
  );
}
